import { render, staticRenderFns } from "./companionsMobile.vue?vue&type=template&id=3302b49a&scoped=true"
import script from "./companionsMobile.vue?vue&type=script&lang=js"
export * from "./companionsMobile.vue?vue&type=script&lang=js"
import style0 from "./companionsMobile.vue?vue&type=style&index=0&id=3302b49a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3302b49a",
  null
  
)

export default component.exports